var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plv-ia-lottery-countdown"},[_vm._t("default",null,{"countdown":_vm.calcDelay})],2)}
var staticRenderFns = []

export { render, staticRenderFns }